(() => {
  const config = document.querySelector('[data-petin-attribution]');
  if (!config) return;
  const key = 'petin_attribution_v1';
  const duration = 30 * 60 * 1000;
  let session;
  let pending = Promise.resolve();
  let lastSaved = '';
  let activeCart = Number(config.dataset.cartCount) > 0;
  const clean = value => /^[a-zA-Z0-9_. -]{1,80}$/.test(value || '') ? value : '';
  const path = () => location.pathname.slice(0,160);
  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const attributionAllowed = () => analyticsAllowed() && window.Shopify?.customerPrivacy?.marketingAllowed() === true;
  const entry = anchor => {
    if (anchor.closest('#header-group')) return 'header';
    const section = anchor.closest('[data-petin-placement]');
    return clean(section?.dataset.petinPlacement) || (anchor.closest('footer') ? 'footer' : 'content');
  };
  const read = () => {
    if (!attributionAllowed()) return null;
    if (session && session.expires > Date.now()) return session;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (saved?.expires > Date.now()) session = saved;
    } catch {}
    if (session?.expires > Date.now()) return session;
    const params = new URLSearchParams(location.search);
    let referrer;
    try { referrer = new URL(document.referrer); } catch {}
    const internal = referrer && referrer.hostname === location.hostname;
    let source = 'direct', medium = 'none';
    if (referrer && !internal) {
      source = /(^|\.)petin\.it$/.test(referrer.hostname) ? 'petin' : 'referral'; medium = 'referral';
      if (/(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com)$/.test(referrer.hostname)) {
        source = /google/.test(referrer.hostname) ? 'google' : /bing/.test(referrer.hostname) ? 'bing' : 'duckduckgo'; medium = 'organic';
      } else if (/(^|\.)(instagram\.com|facebook\.com|pinterest\.[a-z.]+|tiktok\.com)$/.test(referrer.hostname)) {
        source = referrer.hostname.replace(/^(www|l|m)\./,'').split('.')[0]; medium = 'social';
      }
    }
    session = {source:clean(params.get('utm_source')) || source, medium:clean(params.get('utm_medium')) || medium,
      campaign:clean(params.get('utm_campaign')), landing:path(), shop_entry:'', expires:Date.now()+duration};
    save();
    return session;
  };
  const save = () => {
    if (!attributionAllowed() || !session) return;
    try { sessionStorage.setItem(key,JSON.stringify(session)); } catch {}
  };
  const publish = (name, data) => {
    if (!analyticsAllowed() || window.Shopify?.designMode) return;
    try { window.Shopify?.analytics?.publish(`petin:${name}`,data); } catch {}
  };
  const details = placement => {
    const source = read();
    return {page_path:path(),placement,source:source?.source || 'unavailable',medium:source?.medium || 'unavailable',campaign:source?.campaign || ''};
  };
  const decorate = anchor => {
    let url;
    try { url = new URL(anchor.href,location.origin); } catch { return ''; }
    let kind = '';
    if (url.hostname === 'www.sumupbookings.com' && url.pathname.startsWith('/petin-srls')) kind = 'booking';
    if (url.hostname === 'consulenza.petin.it') kind = 'consultation';
    if (!kind) return '';
    const placement = entry(anchor);
    url.searchParams.set('utm_source','petin');
    url.searchParams.set('utm_medium','referral');
    url.searchParams.set('utm_campaign','sito_unico');
    url.searchParams.set('utm_content',`${config.dataset.page}_${placement}`);
    const source = read();
    for (const field of ['source','medium','campaign']) {
      const param = `petin_${field}`;
      if (source?.[field]) url.searchParams.set(param,source[field]);
      else url.searchParams.delete(param);
    }
    anchor.href = url.href;
    anchor.dataset.petinTracking = kind;
    anchor.dataset.petinEntry = placement;
    return kind;
  };
  const syncCart = () => {
    const source = read();
    if (!activeCart || !source || window.Shopify?.designMode) return pending;
    const attributes = {'__petin_source':source.source,'__petin_medium':source.medium,'__petin_campaign':source.campaign,
      '__petin_landing':source.landing,'__petin_shop_entry':source.shop_entry || 'direct_store'};
    const serialized = JSON.stringify(attributes);
    if (serialized === lastSaved) return pending;
    lastSaved = serialized;
    pending = pending.then(() => {
      if (!attributionAllowed()) return;
      return fetch(`${config.dataset.root}cart/update.js`,{method:'POST',credentials:'same-origin',keepalive:true,
        headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})}).then(response => {
          if (!response.ok) lastSaved = '';
        }).catch(() => { lastSaved = ''; });
    });
    return pending;
  };
  const updateLinks = () => document.querySelectorAll('a[href]').forEach(decorate);
  const start = () => { read(); updateLinks(); syncCart(); };
  document.addEventListener('click',event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const kind = decorate(anchor);
    if (kind) { publish(`${kind}_click`,details(entry(anchor))); return; }
    let url;
    try { url = new URL(anchor.href,location.origin); } catch { return; }
    if (url.hostname === 'wa.me') { publish('whatsapp_click',details(entry(anchor))); return; }
    if (url.protocol === 'tel:') { publish('phone_click',details(entry(anchor))); return; }
    if (url.origin !== location.origin) return;
    if (url.searchParams.get('view') === 'boutique' || /\/pages\/boutique$/.test(url.pathname)) {
      const source = read();
      if (source) { source.shop_entry = `${config.dataset.page}_${entry(anchor)}`; save(); syncCart(); }
      publish('boutique_enter',details(entry(anchor)));
    } else if (/\/products\//.test(url.pathname)) publish('product_click',details(entry(anchor)));
  },true);
  document.addEventListener('cart:update',event => {
    if (event.detail?.data?.didError) return;
    const count = event.detail?.resource?.item_count;
    if (typeof count === 'number') activeCart = count > 0;
    else if (event.detail?.data?.source === 'product-form-component') activeCart = true;
    syncCart();
  });
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('[name="form_type"][value="contact"]')) {
      const source = read();
      if (source) {
        let field = form.querySelector('[name="contact[Petin source]"]');
        if (!field) { field = document.createElement('input'); field.type='hidden'; field.name='contact[Petin source]'; form.append(field); }
        field.value = `${source.source} / ${source.medium}; campaign: ${source.campaign || 'none'}; landing: ${source.landing}; entry: ${config.dataset.page}_contact_form`;
      }
      publish('contact_form_attempt',details('contact_form'));
    }
    if (event.submitter?.name === 'checkout') syncCart();
  },true);
  document.addEventListener('visitorConsentCollected',() => {
    if (!attributionAllowed()) {
      session = null;
      try { sessionStorage.removeItem(key); } catch {}
    }
    start();
  });
  if (window.Shopify?.customerPrivacy) start();
  else {
    updateLinks();
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error => { if (!error) start(); });
  }
})();
